import * as React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";

export default class SlideShow extends React.Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      autoplaySpeed: 10000,
      fadeIn: false,
      autoplay: true,
      pauseOnHover: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div
        className={`overflow-hidden ${this.props.className} relative bg-black`}
      >
        <div className="flex justify-between w-full inset-0 absolute ">
          <button className="focus:outline-none z-50" onClick={this.previous}>
            <svg
              className="mx-6 my-5"
              xmlns="http://www.w3.org/2000/svg"
              width="18.443"
              height="30.426"
              viewBox="0 0 18.443 30.426"
            >
              <path
                id="np_arrow_2335739_FFFFFF"
                d="M27.093,15.195,38.135,26.707l-3.877,3.72L19.692,15.195,34.258,0l3.877,3.72Z"
                transform="translate(-19.692 -0.001)"
                fill="#fff"
                fillRule="evenodd"
              />
            </svg>
          </button>
          <button className="focus:outline-none z-50" onClick={this.next}>
            <svg
              className="mx-6 my-5"
              xmlns="http://www.w3.org/2000/svg"
              width="18.443"
              height="30.426"
              viewBox="0 0 18.443 30.426"
            >
              <path
                id="np_arrow_2335739_FFFFFF"
                d="M30.734,15.195,19.692,26.707l3.877,3.72L38.135,15.195,23.569,0l-3.877,3.72Z"
                transform="translate(-19.692 -0.001)"
                fill="#fff"
                fillRule="evenodd"
              />
            </svg>
          </button>
        </div>
        <Slider ref={(c) => (this.slider = c)} {...settings}>
          {this.props.children}
        </Slider>
      </div>
    );
  }
}

// const settings = {
//   dots: true,

//   nextArrow: <NextArrow />,
//   prevArrow: <PrevArrow />,

// const HomePage = () => {
//   return (
//     <main>
//       <NavBar />
//       <Slider {...settings} className="overflow-hidden">
//         <HeroBanner image={summerHero}>
//           <h5>Are you feeling the heat this summer?</h5>
//           <p>
//             Our team is here to<br></br> help you chill out.
//           </p>
//           <a className="text-red" href="/">
//             View our heat pumps
//           </a>
//         </HeroBanner>

//         <HeroBanner image={condensationHero}>
//           <h5>
//             Condensation <br></br> getting you down?
//           </h5>
//           <p>Our team is here to help make your home healthier.</p>
//           <a className="text-lblue" href="/">
//             View our ventilation systems
//           </a>
//         </HeroBanner>

//         <HeroBanner image={showerHero}>
//           <h5>
//             power bill giving<br></br> you the shivers?
//           </h5>
//           <p>Our team can help find a more efficient way to heat your water</p>
//           <a className="text-green" href="/">
//             View our water systems
//           </a>
//         </HeroBanner>
//       </Slider>
//       <Footer />
//     </main>
//   );
// };

// export default PreviousNextMethods;
